import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=1376ff06&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=1376ff06&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1376ff06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1376ff06')) {
      api.createRecord('1376ff06', component.options)
    } else {
      api.reload('1376ff06', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=1376ff06&scoped=true", function () {
      api.rerender('1376ff06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/ChangePassword.vue"
export default component.exports